import clsx from 'clsx'
import React, { ReactNode } from 'react'

import { SliderWithArrowsAndIndicator } from '@Components/Slider/SliderWithArrowsAndIndicator'
import { TileSettings } from '@Components/Tiles/settings'

import styles from './Tiles.module.scss'

const generateStyleVars = (rowsMobile: number | string, rowsDesktop: number | string): React.CSSProperties => {
  const styleVars: React.CSSProperties = {}

  if (typeof rowsMobile === 'string' && rowsMobile !== 'auto') {
    styleVars['--grid-template-rows' as any] = `repeat(${rowsMobile}, 1fr)`
  } else if (typeof rowsMobile === 'number' && rowsMobile !== 1) {
    styleVars['--grid-template-rows' as any] = `repeat(${rowsMobile}, 1fr)`
  }

  if (typeof rowsDesktop === 'string' && rowsDesktop !== 'auto') {
    styleVars['--grid-template-rows-desktop' as any] = `repeat(${rowsDesktop}, 1fr)`
  } else if (typeof rowsDesktop === 'number' && rowsDesktop !== 1) {
    styleVars['--grid-template-rows-desktop' as any] = `repeat(${rowsDesktop}, 1fr)`
  }

  return styleVars
}

const ItemsContainer = ({
  children,
  settings,
}: {
  children: React.ReactNode
  settings: TileSettings
}) => {
  const shouldUseColumnFlowMobile = settings.rowsMobile !== 'auto' && settings.rowsMobile !== 1
  const shouldUseColumnFlowDesktop = settings.rowsDesktop !== 'auto' && settings.rowsDesktop !== 1
  const styleVars = generateStyleVars(settings.rowsMobile, settings.rowsDesktop)

  if (settings.enableSlider) {
    return (
      <SliderWithArrowsAndIndicator
        hideArrows
        sliderClassName={clsx(
          styles.slider,
          shouldUseColumnFlowMobile && styles.columnFlowMobile,
          shouldUseColumnFlowDesktop && styles.columnFlowDesktop,
          styles[settings.cardSize],
        )}
        style={styleVars}
      >
        {children}
      </SliderWithArrowsAndIndicator>
    )
  }

  return (
    <div
      className={clsx(
        styles.list,
        shouldUseColumnFlowMobile && styles.columnFlowMobile,
        shouldUseColumnFlowDesktop && styles.columnFlowDesktop,
        styles[settings.cardSize],
      )}
      style={styleVars}
    >
      {children}
    </div>
  )
}

export const Tiles = ({
  autoFit = false,
  children,
  settings,
}: {
  autoFit?: boolean
  children: ReactNode
  settings: TileSettings
}) => (
  <div className={clsx(styles.container, autoFit && styles.autoFit)}>
    <ItemsContainer settings={settings}>
      {children}
    </ItemsContainer>
  </div>
)

